/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_SizesInputs */

const en_col_sizes = /** @type {(inputs: Col_SizesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizes`)
};

/**
* | output |
* | --- |
* | "Sizes" |
*
* @param {Col_SizesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_sizes = /** @type {((inputs?: Col_SizesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_SizesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_sizes(inputs)
});